import { bannerLoader } from "@/features/banner"
import {
  getExposedFAQCategoryListLoader,
  getExposedFAQListLoader
} from "@/features/faq"
import { getLanguage } from "@/utils/getLanguage"
import { defer, LoaderFunctionArgs } from "react-router-dom"

export type THomeLoader = {
  bannerData: Awaited<ReturnType<typeof bannerLoader>>
  language: Awaited<ReturnType<typeof getLanguage>>
  faqList: Awaited<ReturnType<typeof getExposedFAQListLoader>>
  faqCategoryList: Awaited<ReturnType<typeof getExposedFAQCategoryListLoader>>
}

export const mainLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const faqCategoryId = url.searchParams.get("faqCategoryId")

  const banner = bannerLoader()
  const language = getLanguage()
  const faqCategoryList = await getExposedFAQCategoryListLoader()
  const faqList =
    faqCategoryList.length === 0
      ? []
      : await getExposedFAQListLoader(
          faqCategoryId ? Number(faqCategoryId) : faqCategoryList[0].id
        )

  return defer({
    bannerData: await banner,
    language: await language,
    faqCategoryList,
    faqList
  })
}
